import helpers from './helpers';

export default {
  trackFreeAdminFeeMissionCardImpression({
    productType,
    vendorCode,
    state,
    missionId,
    itemPosition = 0,
  } = {}) {
    const payload = {
      evn: `agenlite_free_admin_fee_mission_card_impression`,
      journey_id: this.getTrackerJourneyId,
      current_screen: this.$route?.name,
      referrer_screen: this.routeReferrer?.name || '',
      product_type: productType,
      state,
      item_position: itemPosition,
    };

    if (missionId) payload.mission_id = `${missionId}`;
    if (vendorCode) payload.vendor_code = vendorCode;

    this.$blTracker.actions.trackActions(payload);
  },
  trackFreeAdminFeeMissionClick({ clickSource, clickSourceStatus, productType, vendorCode, params = {} } = {}) {
    const payload = {
      evn: `agenlite_free_admin_fee_mission_click`,
      journey_id: this.getTrackerJourneyId,
      current_screen: this.$route?.name,
      referrer_screen: this.routeReferrer?.name || '',
      click_source: clickSource,
      params: helpers.generateParams({
        product_type: productType,
        vendor_code: vendorCode,
        ...params,
      }),
    };

    if (clickSourceStatus) payload.click_source_status = clickSourceStatus;

    this.$blTracker.actions.trackActions(payload);
  },
};
